<div fxLayout="column" fxLayoutAlign="center center" class="container" *ngIf="!authService.isLoggedIn()">
  <h2>Logincode eingeben</h2>
  <mat-form-field appearance="fill">
    <mat-label>Logincode eingeben</mat-label>
    <input type="text" matInput placeholder="Logincode eingeben" [(ngModel)]="loginCode" (keyup.enter)="login()" />
  </mat-form-field>
  <button mat-raised-button color="accent" (click)="login()">Login</button>
</div>
<div fxLayout="column" fxLayoutAlign="center center" class="container" *ngIf="authService.isLoggedIn()">
  <h2>Eingeloggt</h2>
  <p>Bitte oben rechts ausloggen</p>
</div>
